import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { PublicationArticleContainer } from "@clientFrontend/features/publication/components/PublicationArticleContainer";
import { PrimaryActionWithNotification } from "@clientFrontend/features/publication/components/PrimaryActionWithNotification";
import { ClientContentDetail } from "@clientFrontend/features/publication/components/ClientContentDetail";
import type { ClientContent } from "@clientFrontend/features/publication/components/ClientContentDetail/types";
import * as styles from "./styles.css";

type Props = {
  clientContent: ClientContent;
  canEdit: boolean;
  editUrl: string;
  dummyImgPath: string;
  site: "biyo" | "kaigo";
};

export const ClientContentShow: FC<Props> = ({
  clientContent,
  canEdit,
  editUrl,
  dummyImgPath,
  site,
}) => {
  return (
    <PublicationArticleContainer>
      <Heading tag="h1" size="xLarge" bold className={styles.pageTitle}>
        企業情報
      </Heading>
      <PrimaryActionWithNotification
        text="編集する"
        url={editUrl}
        iconName="edit"
        canAction={canEdit}
      >
        <p className={styles.approvingDuration}>
          ご申請から反映までの目安&nbsp;
          <span className={styles.approvingDurationExp}>最大3営業日以内</span>
        </p>
      </PrimaryActionWithNotification>
      <ClientContentDetail
        clientContent={clientContent}
        canEdit={canEdit}
        editUrl={editUrl}
        dummyImgPath={dummyImgPath}
        site={site}
      />
    </PublicationArticleContainer>
  );
};
